<script>
  import Router from 'svelte-spa-router'
  import Header from './widgets/Header.svelte'
  import Footer from './widgets/Footer.svelte'
  import Home from './pages/Home.svelte';
  import Recruit from './pages/Recruit.svelte';
  import Company from './pages/Company.svelte';
  import About from './pages/About.svelte';
  import Info from './pages/Info.svelte';
  import Service from './pages/Service.svelte';
import Contact from './pages/Contact.svelte';
import News from './pages/News.svelte';
import NewsArticle from './pages/NewsArticle.svelte';
import Policy from './pages/Policy.svelte';
import Products from './pages/Products.svelte';
  const routes = {
    '/': Home,
    '/recruit': Recruit,
    "/service":Service,
    "/company":Company,
    "/company/about":About,
    "/company/info":Info,
    "/company/info/*":Info,
    "/contact":Contact,
    "/product":Products,
    "/news":News,
    "/privacy":Policy,
    "/news/:id/":NewsArticle,
    '*': Home
  };
  const routeLoaded = ()=>{
    const result = window.location.href.match(/#(?!\/).+/g)
    if(result && result.length === 1){
      const elm = document.querySelector(result[0])
      elm.scrollIntoView()
    }
  }
</script>

<main>
	<Header />
	<Router 
    routes={routes} 
    restoreScrollState={true}
    on:routeLoaded={routeLoaded}
  />
  <Footer />
</main>

<style>
	*{
		margin:0;
		padding: 0;
	}
  :global(html){
    scroll-padding: 120px;
  }
</style>